import * as React from 'react';
import './IndividualCard.scss';

export interface IIndividualCard {
  label: string;
  imageUrl: string;
  buttonText: string;
  backgroundURl: string;
  cardName: string;
  buttonLink: string;
}

class IndividualCard extends React.Component<IIndividualCard, any> {
  public render() {
    return (
      <div className="individualcard-parent">
        <div
          className={`individual-card ${this.props.cardName}`}
          style={{
            backgroundImage: `url(${this.props.backgroundURl})`
          }}
        >
          <p className="individual-card-label">{this.props.label}</p>
          <div
            className="individual-card-image"
            style={{
              backgroundImage: `url(${this.props.imageUrl})`
            }}
          />
          <button className="explore-button">
            <a className="buttonLink" href={this.props.buttonLink}>
              {this.props.buttonText}
            </a>
          </button>
        </div>
      </div>
    );
  }
}

export default IndividualCard;
